exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PinnedList-39182b20{padding:20px 20px}.IntroWidget-d0405c35{padding:20px 20px}.resultsFooter-a5d0fabd{padding:20px;text-align:center}.footerText-cf82abbe{font-style:italic;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"PinnedList": "PinnedList-39182b20",
	"IntroWidget": "IntroWidget-d0405c35",
	"resultsFooter": "resultsFooter-a5d0fabd",
	"footerText": "footerText-cf82abbe"
};